import { FC } from 'react';

import style from './HelperReason.module.scss';

type Props = {
  question_text: string;
  handleModalOpen: () => void;
};

const InputHelperReason: FC<Props> = ({ question_text, handleModalOpen }) => {
  return (
    <div onClick={handleModalOpen} className={style.question_button}>
      <img src="/images/iqfu/chat/helper_question_icon.svg" alt="?" />
      <span>{question_text}</span>
    </div>
  );
};

export default InputHelperReason;
